import { render, staticRenderFns } from "./StoreContent.vue?vue&type=template&id=61b0f684"
import script from "./StoreContent.vue?vue&type=script&lang=js"
export * from "./StoreContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports